"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Card_1 = __importDefault(require("@mui/material/Card"));
var ErrorMessageProvider_1 = require("../../Atoms/ErrorMessageProvider/ErrorMessageProvider");
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeCardButtonStyling_1 = __importStar(require("./makeCardButtonStyling"));
var CardButton = function (_a) {
    var children = _a.children, onClick = _a.onClick, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, selected = _a.selected, outlined = _a.outlined, experimentName = _a.experimentName, disabled = _a.disabled, fitContent = _a.fitContent, otherProps = __rest(_a, ["children", "onClick", "onBlur", "onKeyDown", "selected", "outlined", "experimentName", "disabled", "fitContent"]);
    var errorMessage = (0, ErrorMessageProvider_1.useErrorMessage)({
        isErrorMessageProviderRequired: false,
    }).errorMessage;
    return ((0, jsx_runtime_1.jsx)(Card_1.default, __assign({ css: (0, makeCardButtonStyling_1.default)({
            isError: errorMessage !== undefined,
            selected: selected,
            outlined: outlined,
            disabled: disabled,
            fitContent: fitContent,
        }), onClick: disabled ? undefined : onClick, onKeyDown: disabled ? undefined : onKeyDown, onBlur: onBlur }, otherProps, { children: (0, jsx_runtime_1.jsx)("div", { css: (0, makeCardButtonStyling_1.makeCardButtonSelectedOverlayStyling)({ selected: selected, fitContent: fitContent }), children: children }) })));
};
CardButton.defaultProps = defaultProps_1.default;
exports.default = CardButton;
//# sourceMappingURL=CardButton.js.map